const defaultConfig = {
  canny_url: "https://deftgpt.canny.io/feature-requests",
  canny_bug_url: "https://deftgpt.canny.io/bugs",
  upgrade_url: `${process.env.REACT_APP_BASEURL}/settings/current-plan`,
  autoLogin_url:`${process.env.REACT_APP_BASEURL}/auto-login`,
};

export default defaultConfig;
